/**
 * Formats a date string into display components for the UI.
 * Returns { month: "DEC", day: "11", label: "Thursday, December 11", time: "9:30AM - 11:30AM EST" }
 */
export const formatSessionDate = (
  dateStart: string | null,
  dateEnd: string | null,
  durationSeconds: number,
): { month: string; day: string; label: string; time: string } => {
  if (!dateStart) {
    return { month: 'TBD', day: '--', label: 'Date to be announced', time: 'Time TBD' };
  }

  const start = new Date(dateStart);

  const month = start.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
  const day = start.getDate().toString();
  const label = start.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });

  // Time range (e.g., "9:30AM - 11:30AM CST")
  const startTime = formatTime(start);
  let endTime: string;

  if (dateEnd) {
    endTime = formatTime(new Date(dateEnd));
  } else if (durationSeconds > 0) {
    const endDate = new Date(start.getTime() + durationSeconds * 1000);

    endTime = formatTime(endDate);
  } else {
    endTime = '';
  }

  const timezone = start.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ').pop();
  const time = endTime ? `${startTime} - ${endTime} ${timezone}` : `${startTime} ${timezone}`;

  return { month, day, label, time };
};

const formatTime = (date: Date): string => {
  return date
    .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
    .replace(' ', '')
    .toUpperCase();
};
